import { SupabaseDownloadSignatureRequestPdfRepository } from '@/shared/infra/repositories'
import type { DownloadSignatureRequestPdf } from '@/shared/domain'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'

export function makeDownloadSignatureRequestPdf(): DownloadSignatureRequestPdf {
  return new SupabaseDownloadSignatureRequestPdfRepository(
    makeSupabaseEdgeHttpClient(),
  ).execute
}
